import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Title from '../title/Title';
import EirButton from '../eir-button/EirButton';
import Subtitle from '../subtitle/Subtitle';
import CountdownTimer from '../countdown-timer/CountdownTimer';
import { LargeBusiness, moduleMargins } from '../../Constants';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";

class TitleContainer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    let [marginDesktop, marginMobile] = moduleMargins(this.props.MarginDT, this.props.MarginMobile);
    const classes= {Container: LargeBusiness.isLBSite ? " eir-title-container eir-lb-title-container" : " eir-title-container",
                          margin: isMobile ? marginMobile : marginDesktop};
    return (
        <Container className={classes.Container + classes.margin + ' mb-3 mb-md-5 mt-5' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default') + (this.props.countdownTimer ? ' countdown' : '' )+ ' ' + (this.props.className ? this.props.className : '')}>

          <Row className="h-100">        
            <Col xs="12" md={{ size: 8, offset: 2 }} className={(isMobileOnly || !LargeBusiness.isLBSite) ? "h-100 d-flex flex-column justify-content-center align-items-center text-center": "h-100 d-flex flex-column" }>
             <Title
                title={this.props.title}
                titleColor={this.props.titleColor}
                titleHeight={this.props.titleHeight} 
                fluid={this.props.fluid} 
                useH1={this.props.useH1}
             />

             
              <Subtitle className={(LargeBusiness.isLBSite?"w-100":"")} text={this.props.text} />

              {this.props.cta &&
                <EirButton {...this.props.cta} />
              }

              {this.props.countdownTimer &&
                  <CountdownTimer className="pt-3 pt-md-5" date={this.props.countdownTimer.dateTime} title={this.props.countdownTimer.title}/>
              }

            </Col>
          </Row>

        </Container>
    );
  }
}

export default TitleContainer;
